import { useQuery } from "@tanstack/react-query"
import { ApplicationRoleGet } from "../app/models/ApplicationRole"
import { digitalManagerApi } from "../services/api"

export function useApplicationRoles(applicationId?: string) {
  const { data: applicationRoles = [], isLoading: isLoadingApplicationRoles } = useQuery({
    queryKey: ["applicationRoles", applicationId],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationRoleGet[]>(`/applications/${applicationId}/roles`)
        .then((r) => r.data),
    enabled: !!applicationId,
  })

  return { applicationRoles, isLoadingApplicationRoles }
}
